import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';

export const importVaultNotes = (notes) => httpsCallable(functions, 'importVaultNotes')({ notes }).then((result) => result.data);
